import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../lib/api.ts';
import { useStore } from '../lib/store.ts';

export function useFTPTest() {
  const { t } = useTranslation();
  const setFTP = useStore((s) => s.setFTP);
  const addToast = useStore((s) => s.addToast);

  return useMutation({
    mutationFn: (avgPower: number) => api.ftpTest({ avg_power_20min: avgPower }),
    onSuccess: (data) => setFTP(data.ftp),
    onError: () => addToast({ message: t('errors.ftpCalcFailed'), type: 'error' }),
  });
}
